module.exports = {
  emptyMessage: 'Complete with the name as it appears on the card.',
  containsNumberMessage: 'The name cannot contain numbers',
  maxLengthMessage: 'Oops! You have exceeded the number of characters allowed, please fill it again.',
  defaultMessage: 'Oops! This is an invalid name.',
};
